import { t } from "i18next";
import { useEffect } from "react";
import { Label, Input, InputProps } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import { GenerateSequenceNumberRequest, State } from "../../interfaces";
import { generateSequenceNumber } from "../../store/actions";

type TProps = InputProps &
  React.InputHTMLAttributes<HTMLInputElement> & {
    request: GenerateSequenceNumberRequest;
    onGenerateSequenceNumber: (sequenceNumber: number) => void;
    mode: "edit" | "add";
  };
export const SequenceNumberInput: React.FC<TProps> = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.mode === "add") {
      dispatch(generateSequenceNumber(props.request));
    }
  }, [props.sequenceType]);

  const {
    loading: getSequenceNumberLoading,
    success: getSequenceNumberSuccess,
    response: getSequenceNumberResponse,
  } = useSelector(
    (state: any): State<{ sequenceNumber: number }> =>
      state.appSettings.sequenceNumber
  );

  useEffect(() => {
    if (
      !getSequenceNumberLoading &&
      getSequenceNumberSuccess &&
      props.mode === "add"
    ) {
      if (getSequenceNumberResponse) {
        const { sequenceNumber } = getSequenceNumberResponse;
        props.onGenerateSequenceNumber(sequenceNumber);
      }
    }
  }, [getSequenceNumberLoading, getSequenceNumberSuccess]);

  return (
    <div className="mb-3">
      <Label htmlFor="sequenceNumber" className="form-label">
        {t("sequenceNumber")}
        <span className="text-danger">*</span>
      </Label>
      <Input
        {...props}
        type="text"
        className="form-control"
        id="sequenceNumber"
        name="sequenceNumber"
        placeholder={`${t("enterSequenceNumber")}`}
        minLength={1}
        maxLength={5}
      />
    </div>
  );
};
